export var ROW_SIZE = 43;
export var DROPDOWN_LIST_HEIGHT = 245;
export var ClickOutsideArea;
(function(ClickOutsideArea) {
    /** The area that was clicked outside of was the input */ ClickOutsideArea[ClickOutsideArea["INPUT"] = 0] = "INPUT";
    /** The area that was clicked outside of was the dropdown menu */ ClickOutsideArea[ClickOutsideArea["MENU"] = 1] = "MENU";
})(ClickOutsideArea || (ClickOutsideArea = {}));
